import LayoutPage from '@/view/layout/LayoutApp'

/*
 * Variante embebida en la app móvil. Igual que en la web, ERM 2026 tiene una
 * sola ficha por mesa: la ruta de la ficha de local se retiró.
 */
export default [{
    path: '/sheet-app',
    component: LayoutPage,
    children: [{
        path: 'mesa/edit/:procesoElectoralId/:localVotacionId/:mesaVotacionId/:turno?',
        name: 'sheet-mesa-edit-app',
        component: () => import('@/view/sheet/2026-ERM/EditFicha'),
        props: () => {
            return { esVersionApp: true }
        }
    }]
}]
